export { Badge } from './Badge';
export type { Props } from './Badge.types';
